import { render, staticRenderFns } from "./OneColumn.vue?vue&type=template&id=4d58b96a&scoped=true&"
import script from "./OneColumn.vue?vue&type=script&lang=js&"
export * from "./OneColumn.vue?vue&type=script&lang=js&"
import style0 from "./OneColumn.vue?vue&type=style&index=0&id=4d58b96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58b96a",
  null
  
)

export default component.exports